// src/components/filter.
import React, { useEffect, useMemo, useState,useRef } from "react";
import { Row, Col, CardBody, Card } from "reactstrap";
//import components
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { AdminService } from "services/AdminService";
import { toast } from "react-toastify";
toast.configure();
import "react-toastify/dist/ReactToastify.css";
import { Driver } from "models/Driver";
import DriverTableContainer from "components/Common/DriverTableContainer";
import DriverDetailsModal from "modals/DriverDetailsModal";
import Swal from "sweetalert2";
import "../../assets/css/custom.css";
import { Puff } from "react-loader-spinner";
import { format, parseISO } from "date-fns";
import { useUserCount } from 'context/UserCountProvider';


const PendingDrivers: React.FC = () => {
  const [drivers, setDrivers] = useState([] as Driver[]);
  const [driverId, setDriverId] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [LIMIT_P_C, setLIMIT_P_C] = useState(10);

 const { updateUserCounts } = useUserCount();
  const mapprops: any = {
    componentRestrictions: { country: "ca" },
    locationRestriction: {
      north: 56.85,    // Northeast corner latitude (Keep this as is)
      south: 41.6,     // Southwest corner latitude (Keep this as is)
      east: -74.0,     // Adjusted Northeast corner longitude to cover Kingston and Cornwall
      west: -95.15     // Keep this as is to cover the entire Ontario province
    }
  };
  const columns = useMemo(
    () => [
      {
        Header: "Driver Id",
        accessor: "customerId",
      },
      {
        Header: "Driver Name",
        accessor: "firstName",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Registered Date",
        accessor: "createdAt",
         Cell: ({ value }: any) => {
          return format(new Date(value), "dd.MM.yyyy");
        },
      },
    
       
      {
        Header: "Address",
        accessor: "address.city",
        Cell: ({ row }: any) => {
          const value = row.original.address.city.split(",");
          const count = value.length;
          const city = count - 3 >= 0 ? value[count - 3] : "";
          return city;
        },
      },
      {
        Header: "Phone Number",
        accessor: "phoneNumber",
      },
      {
        id: "action",
        Header: "Action",
        accessor: "_id",
        Cell: ({ row }: any) => {
          const verifiedStatus = row.original.verifiedStatus;
          return (
            <div className="text-center">
              {verifiedStatus === "approved" ? (
                <button
                  className="btn btn-primary btn-sm me-lg-2 mb-2"
                  onClick={() => handleVerifiedUser(row)}>
                  Verify User
                </button>
              ) : (
                <button
                  disabled
                  className="btn btn-primary btn-sm me-lg-2 mb-2"
                >
                  Verified
                </button>
              )}
              <button className="btn btn-outline-success btn-sm me-lg-2  mb-2" onClick={() => handleAction(row)}>
                View
              </button>
              <button className="btn btn-outline-danger btn-sm  mb-2" onClick={() => deleteDriver(row)}>
                Delete
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const [isOffset_p_c, setOffset_p_c] = useState<number>(1);
  const [seeMore_p_c, setSeeMore_p_c] = useState(false);
  const [pageCount, setPageCount] = useState<number>(1);
  const [isloading, setIsloading] = useState<boolean>(true);
   

  useEffect(() => {
    setIsloading(true);
    AdminService.getPendingDrivers(LIMIT_P_C, isOffset_p_c).then(res => {
      if (res.success) {
        console.log("pending****",res.data.driverList)
        setDrivers(res.data.driverList);
        setSeeMore_p_c(!(res.data.driverList.length > 0 && res.data.driverList.length == LIMIT_P_C));
        setPageCount(Math.ceil(res.data.count / LIMIT_P_C));
         updateUserCounts({ pendingDriverCount: res.data.count });
      } else {
        setSeeMore_p_c(true);
      }
    });
    setIsloading(false);
  }, [isEditClicked]);

  const SeeMore = (page: any) => {
    setOffset_p_c(page.selected + 1);
    AdminService.getPendingDrivers(LIMIT_P_C, page.selected + 1).then(res => {
      if (res.success) {
        setDrivers(res.data.driverList);
        setSeeMore_p_c(!(res.data.driverList.length > 0 && res.data.driverList.length == LIMIT_P_C));
         updateUserCounts({ pendingDriverCount: res.data.count });
      } else {
        setSeeMore_p_c(true);
      }
    });
  };


  const deleteDriver = (values: any) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(result => {
      if (result.isConfirmed) {
        AdminService.deleteDriverById(values.original?._id).then(res => {
          if (res.success) {
            SeeMore(isOffset_p_c);
            Swal.fire("Driver Removed");
          } else {
            Swal.fire({
              icon: "error",
              title: res.error,
              confirmButtonColor: "#FD7F00",
            });
          }
        });
      }
    });
  };

  const handleColumnChange = (selectedOption: any) => {
    setLIMIT_P_C(selectedOption.value);
    AdminService.getPendingDrivers(selectedOption.value, 1).then(res => {
      if (res.success) {
        setDrivers(res.data.driverList);
        setSeeMore_p_c(!(res.data.driverList.length > 0 && res.data.driverList.length == LIMIT_P_C));
        setPageCount(Math.ceil(res.data.count / selectedOption.value));
      } else {
        setSeeMore_p_c(true);
      }
    });
  };

  const handleAction = (values: any) => {

    toggleOrderModalInput(values.original?._id);
  };



  const handleModal = () => {
    setIsClicked(!isClicked);
  };

  const toggleOrderModalInput = (id: any) => {
    setDriverId(id);
    setIsClicked(isClicked => {
      if (!isClicked) {
        handleModal();
      }
      return !isClicked;
    });
  };


  // const handleVerifiedUser = (values: any) => {
  //     setDriverId(values.original?._id);
  //     Swal.fire({
  //       title: "Do you want to verified this driver?",
  //       icon: "warning",
  //       showCancelButton: true,
  //       confirmButtonColor: "#F75D21",
  //       cancelButtonColor: "#A9A9A9",
  //       confirmButtonText: "Yes, verified it!",
  //     }).then(result => {
  //       if (result.isConfirmed) {
  //         const driverdata = {
  //           _id: values.original?._id,
  //         }
  //         AdminService.updateDriverStatus(driverdata).then(res => {
  //           if (res.success) {
  //             setIsEditClicked(!isEditClicked)
  //             // if (drivers && drivers?.length > 0) {
  //             //   const updatedDrivers = updateVerifiedStatus(drivers, values.original?._id, "verified");
  //             //   setDrivers(updatedDrivers)
  //             // }
  //             AdminService.getPendingDrivers(LIMIT_P_C, isOffset_p_c).then(res => {
  //           if (res.success) {
  //             setDrivers(res.data.driverList);
  //             setSeeMore_p_c(!(res.data.driverList.length > 0 && res.data.driverList.length == LIMIT_P_C));
  //             updateUserCounts({ pendingDriverCount: res.data.count });
  //           }
  //         });

  //             Swal.fire({
  //               icon: "success",
  //               text: "Driver verified",
  //               confirmButtonColor: "#F75D21",
  //             })
  //           } else {
  //             Swal.fire({
  //               icon: "error",
  //               title: res.error,
  //               confirmButtonColor: "#F75D21",
  //             })
  //           }
  //         })
  //           .catch(error => {
  //             console.error(error)
  //           })
  //       }
  //     })
  //   };




    const handleVerifiedUser = (values: any) => {
      setDriverId(values.original?._id);
    
      Swal.fire({
        title: "Verify this driver?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#F75D21",
        cancelButtonColor: "#A9A9A9",
        confirmButtonText: "Yes",
      }).then(result => {
        if (result.isConfirmed) {
          
          Swal.fire({
            title: "Set Driver Percentage",
            input: "number",
            inputLabel: "Enter % for earnings split",
            inputValue: values.original?.percentage || 0,
            showCancelButton: true,
          }).then(async percentResult => {
            if (percentResult.isConfirmed) {
              const driverdata = {
                _id: values.original?._id,
                percentage: percentResult.value
              };
    
              AdminService.updateDriverStatus(driverdata).then(res => {
                if (res.success) {
                  setIsEditClicked(!isEditClicked);
    
                  AdminService.getPendingDrivers(LIMIT_P_C, isOffset_p_c).then(res => {
                    if (res.success) {
                      setDrivers(res.data.driverList);
                      setSeeMore_p_c(!(res.data.driverList.length > 0 && res.data.driverList.length == LIMIT_P_C));
                      updateUserCounts({ pendingDriverCount: res.data.count });
                    }
                  });
    
                  Swal.fire({
                    icon: "success",
                    text: "Driver verified and percentage updated",
                    confirmButtonColor: "#F75D21",
                  });
                } else {
                  Swal.fire({
                    icon: "error",
                    title: res.error,
                    confirmButtonColor: "#F75D21",
                  });
                }
              });
            }
          });
        }
      });
    };
    

  const searchTable = (serchText: string) => {
    const searchdata = {
      searchableString: serchText,
    };
    AdminService.getPendingDriverBySearch(searchdata, LIMIT_P_C, isOffset_p_c).then(res => {
      if (res.success) {
        if (res.data.length !== 0) {
          setDrivers(res.data);
        }
      }
    });
  };

  //meta title
  document.title = "Manage Drivers";

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="Pending Drivers" breadcrumbItem={"Create"} />
        <Col lg={12}>
          <Card>
            <CardBody>
            <DriverDetailsModal isOpen={isClicked} handleIsOpen={handleModal} driverId={driverId} />
              <div>Pending Driver List</div>
              {isloading? <div className="d-flex justify-content-center align-items-center"  style={{ height: '500px' }}>
                  <Puff color="#FFD0B8" height={50} width={50} />
                </div>:
              <>{drivers.length > 0 ? (
                <DriverTableContainer
                  columns={columns}
                  data={drivers}
                  currentPage={isOffset_p_c}
                  pagelimit={pageCount}
                  handlePageChange={SeeMore}
                  handleSearch={searchTable}
                  handleColumnChange={handleColumnChange}
                  selectedColumns={LIMIT_P_C}
                  isGlobalFilter={true}
                  isAddOptions={false}
                  customPageSize={50}
                  className="custom-header-css"
                  isJobListGlobalFilter={undefined}
                  isAddUserList={undefined}
                  handleOrderClicks={undefined}
                  handleUserClick={undefined}
                  handleCustomerClick={undefined}
                  isAddCustList={undefined}
                  customPageSizeOptions={undefined}
                  isPDFGenerate={true}
                  ispopup={true}
                  isAddressBook={false}
                  hancleDeleteRecords={undefined}
                  handleSelect={undefined}
                  selectedID={undefined}
                  isABusiness={true}
          
                />
              ) : (
                <Row className="justify-content-md-center justify-content-center align-items-center">
                  <Col className="col-md-auto">
                    <div>No Drivers to show</div>
                  </Col>
                </Row>
              )}</>}
            </CardBody>
          </Card>
        </Col>
      </div>
    </div>
  );
};

export default PendingDrivers;
